import { useEffect } from "react";
import { useLocation } from "react-router";
import { shallow } from "zustand/shallow";
import HeaderPc from "@core/layouts/header/components/HeaderPc";
import HeaderMobile from "@core/layouts/header/components/HeaderMobile";
import { useUiStore } from "@core/stores/uiStore";
import { useAuthStore } from "@core/stores/authStore";

export default function Header() {
  const isLoginLoading = useAuthStore((state) => state.isLoginLoading);
  const { isPcView, setIsCnbOpen } = useUiStore(
    (state) => ({
      isPcView: state.isPcView(),
      setIsCnbOpen: state.setIsCnbOpen,
    }),
    shallow,
  );
  const location = useLocation();

  useEffect(() => {
    setIsCnbOpen(false);
  }, [location.pathname, setIsCnbOpen]);

  return isPcView ? <HeaderPc isLoginLoading={isLoginLoading} /> : <HeaderMobile isLoginLoading={isLoginLoading} />;
}
